module.exports = __webpack_public_path__ + "img/battery.1394d475.webp";